module.exports = __webpack_public_path__ + "img/section8_1.f1c4f0a3.jpg";